import { Business } from '../business';
import { LeadSubscription } from '../lead';
import { exampleUserRole, UserRole } from './UserRole';
import { exampleTutorialProgress, TutorialProgress } from './Tutorial';
import { Auth0Role } from './UserRoleDTO';
import { User as AuthUser } from 'auth0';

export type UserType =
  | 'Client'
  | 'Administrator'
  | 'Pod Member'
  | 'Analytics Manager'
  | 'Developer';

export type GoodDataAccess =
  | 'None'
  | 'Individual'
  | 'Viewer'
  | 'Analyzer'
  | 'Editor';
export type Auth0Provider = 'google-oauth2' | 'facebook' | 'auth0';
export type Auth0Id = `${Auth0Provider}|${string}`;

export interface User {
  id: number;
  firstName: string;
  lastName: string;
  branchID?: number;
  podID?: number;
  email: string;
  type: UserType;
  // role: UserRole;
  auth0Roles?: Auth0Role[];
  businesses?: Business[];
  fbConnected: boolean;
  googleConnected: boolean;
  profilePicture?: string;
  tutorial: TutorialProgress;
  creativeHubTutorialCompleted: boolean;
  phone?: string;
  calendlyLink?: string;
  notificationEmail?: string;
  acceptedInvite: boolean;
  inviteSentTime?: Date | null;
  createdAt?: string; // ISO Date
  updatedAt?: string; // ISO Date
  webBuilder?: boolean;
  privacyAddendum?: Date;
  theme?: number;
  userBusinesses?: LeadSubscription[];
  assignedRoles: Auth0Role[];
  permissions: string[];
}

export interface UserWithBusiness extends User {
  businesses: Business[];
}

export interface PaginatedUsersResponse {
  users: UserWithBusiness[];
  page: number;
  count: number;
}

export interface NewUserResponse {
  user: UserWithBusiness;
  message: string;
}

export const exampleUser: User = {
  id: 0,
  firstName: '',
  lastName: '',
  // role: exampleUserRole,
  type: 'Client',
  fbConnected: true,
  googleConnected: false,
  email: 'test@wow.com',
  businesses: [],
  tutorial: exampleTutorialProgress,
  profilePicture: 'http://fb.com/profile.png',
  creativeHubTutorialCompleted: false,
  acceptedInvite: true,
  assignedRoles: [],
  permissions: [],
};

export type Auth0User = AuthUser;

export type Auth0UserWithRoles = Auth0User & { roles: Auth0Role[] };
